<script setup lang="ts">
import PlaceholderPage from '@app/pages/PlaceholderPage.vue'
</script>

<template>
  <PlaceholderPage section="Compliance" title="Usource Of Funds" />
</template>
